<template>
	<div class="column-wrap" :style="columnWrapStyle">
		<div v-show="isTimerEnabled" class="wrap-timer">
			<div
				class="timer"
				v-if="isTimer && !isTimeEnd"
				:class="isTimeAlmostOver ? 'timeAlmostOver' : ''"
			>
				<svg
					width="32"
					height="32"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M16 5.33341C18.6673 5.33341 21.1313 6.20363 23.1236 7.67563L23.0572 7.60956C22.5365 7.08886 22.5365 6.24464 23.0572 5.72394C23.5378 5.24329 24.2941 5.20632 24.8172 5.61302L24.9428 5.72394L27.6095 8.3906C28.1302 8.9113 28.1302 9.75552 27.6095 10.2762C27.1288 10.7569 26.3725 10.7938 25.8495 10.3871L25.7239 10.2762L25.6578 10.2098C27.1298 12.2021 28 14.6662 28 17.3334C28 23.9608 22.6274 29.3334 16 29.3334C9.37258 29.3334 4 23.9608 4 17.3334C4 10.706 9.37258 5.33341 16 5.33341ZM16 8.00008C10.8453 8.00008 6.66667 12.1788 6.66667 17.3334C6.66667 22.4881 10.8453 26.6667 16 26.6667C21.1547 26.6667 25.3333 22.4881 25.3333 17.3334C25.3333 12.1788 21.1547 8.00008 16 8.00008ZM16 10.6667C16.7364 10.6667 17.3333 11.2637 17.3333 12.0001V17.3334C17.3333 18.0698 16.7364 18.6667 16 18.6667C15.2636 18.6667 14.6667 18.0698 14.6667 17.3334V12.0001C14.6667 11.2637 15.2636 10.6667 16 10.6667ZM20 2.66675C20.7364 2.66675 21.3333 3.2637 21.3333 4.00008C21.3333 4.73646 20.7364 5.33342 20 5.33342H12C11.2636 5.33342 10.6667 4.73646 10.6667 4.00008C10.6667 3.2637 11.2636 2.66675 12 2.66675H20Z"
						fill="#fff"
					/>
				</svg>

				<span>{{ countDown }}</span>
			</div>
		</div>

		<div
			class="column-group highlighted-content"
			:class="{ multiply: isMultiply || isDivide }"
			v-if="!isTimer || (isTimer && !isTimeEnd)"
		>
			<template v-for="(user, userIndex) in userNames">
				<div
					:key="userIndex"
					class="column"
					:class="!!answers[userIndex] && 'column_disabled'"
					v-if="howShow(userIndex)"
				>
					<p v-if="isHomework" class="column-task">
						<span>{{ userIndex + 1 }}</span>
					</p>

					<p v-else class="column-name">{{ user }}</p>

					<ul
						v-if="!isMultiply && !isDivide"
						data-type="column-numbers"
						class="column-number list-unstyled"
					>
						<li
							v-for="(number, index) in columnNumbers[userIndex]"
							:key="index"
							:style="`font-size: ${fontSize}px`"
						>
							{{ operationSymbol(number) }}
						</li>
					</ul>

					<p
						v-if="isMultiply || isDivide"
						class="multiply-column-number"
						:style="`font-size: ${numbersFontSize}px`"
					>
						{{ operationSymbol(columnNumbers[userIndex][0]) }}
						{{ operationSymbol(columnNumbers[userIndex][1]) }}
					</p>

					<form
						:disabled="!!answers[userIndex]"
						class="column-form"
						@submit="e => submitResult(e, userIndex, userIds[userIndex])"
					>
						<div class="input-wrap">
							<input
								v-if="
									typeof rightColumnAnswers[
										getResultByID(userIds[userIndex], userIndex)
									] !== 'string' &&
										typeof rightColumnAnswers[
											getResultByID(userIds[userIndex], userIndex)
										] !== 'number'
								"
								:disabled="!!answers[userIndex]"
								pattern="^[-+]?\d*$"
							/>
							<input
								v-else
								:value="
									rightColumnAnswers[
										getResultByID(userIds[userIndex], userIndex)
									]
								"
								:disabled="!!answers[userIndex]"
								pattern="^[-+]?\d*$"
							/>
						</div>
						<button
							class="btn-pink"
							type="submit"
							:disabled="!!answers[userIndex]"
						/>
					</form>
				</div>
			</template>
		</div>
		<div v-else-if="isTimeEnd && isTimer">
			<h3 class="timeIsOver">{{ 'timeIsOver' | translate }}:(</h3>
		</div>

		<div
			class="slide-control"
			v-if="(view === 'mobile' || view === 'laptop') && !isTimeEnd"
		>
			<button :disabled="this.step <= 0" @click="prev">
				<svg
					width="20"
					height="16"
					viewBox="0 0 20 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M8.7903 0.387101L8.70711 0.292893C8.34662 -0.0675907 7.77939 -0.0953203 7.3871 0.209705L7.29289 0.292893L0.292893 7.29289L0.251496 7.33685L0.196335 7.40469L0.124671 7.51594L0.0712255 7.62866L0.0358451 7.73401L0.00690716 7.8819L0 8L0.00278786 8.07524L0.0202401 8.20073L0.0497381 8.31214L0.0936734 8.42322L0.145995 8.52071L0.219689 8.62545L0.292893 8.70711L7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.06759 15.3466 9.09532 14.7794 8.7903 14.3871L8.70711 14.2929L3.416 9H19C19.5523 9 20 8.55229 20 8C20 7.44772 19.5523 7 19 7H3.414L8.70711 1.70711C9.06759 1.34662 9.09532 0.779392 8.7903 0.387101L8.70711 0.292893L8.7903 0.387101Z"
						fill="#e4467b"
					/>
				</svg>
				<span>{{ 'Back' | translate | textCapitalize }}</span>
			</button>
			<button :disabled="step === maxStep - 1" @click="next">
				<span>{{ 'next' | translate | textCapitalize }}</span>
				<svg
					style="transform: scale(-1,1);"
					width="20"
					height="16"
					viewBox="0 0 20 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M8.7903 0.387101L8.70711 0.292893C8.34662 -0.0675907 7.77939 -0.0953203 7.3871 0.209705L7.29289 0.292893L0.292893 7.29289L0.251496 7.33685L0.196335 7.40469L0.124671 7.51594L0.0712255 7.62866L0.0358451 7.73401L0.00690716 7.8819L0 8L0.00278786 8.07524L0.0202401 8.20073L0.0497381 8.31214L0.0936734 8.42322L0.145995 8.52071L0.219689 8.62545L0.292893 8.70711L7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.06759 15.3466 9.09532 14.7794 8.7903 14.3871L8.70711 14.2929L3.416 9H19C19.5523 9 20 8.55229 20 8C20 7.44772 19.5523 7 19 7H3.414L8.70711 1.70711C9.06759 1.34662 9.09532 0.779392 8.7903 0.387101L8.70711 0.292893L8.7903 0.387101Z"
						fill="#e4467b"
					/>
				</svg>
			</button>
		</div>
	</div>
</template>

<script>
import update from 'immutability-helper'

const interval = 100
let msCounter = 0
let intervalId = undefined
const VIEW = {
	mobile: 'mobile',
	laptop: 'laptop',
	desktop: 'desktop',
}
const VIEW_NUM = {
	mobile: 1,
	laptop: 3,
	desktop: 10,
}
export default {
	name: 'columns',
	props: {
		columnNumbers: Array,
		users: Array,
		isHomework: Boolean,
		gameDataIds: Array,
		rightColumnAnswers: Array,
		initialTimer: Number,
		isTimerEnabled: Boolean,
		gameType: String,
	},

	data: () => ({
		isTimeEnd: false,
		isTimeAlmostOver: false,
		countDown: null,
		fontSize: 16,
		answers: [],
		step: null,
		maxStep: null,
		windowWidth: window.innerWidth,
		txt: '',
		view:
			window.innerWidth > 1200
				? VIEW.desktop
				: window.innerWidth >= 780
				? VIEW.laptop
				: VIEW.mobile, // 'laptop', 'mobile'
	}),
	watch: {
		isTimeEnd: {
			handler() {
				this.answers = this.answers.map(el =>
					!el
						? {
								answer: null,
								correct: false,
								time: 0,
								user: null,
								userId: null,
						  }
						: el
				)
				setTimeout(() => {
					this.$emit('onSubmitAllColumns', this.answers, this.isTrain)
				}, 1000)
			},
		},
	},
	computed: {
		userNames() {
			const source =
				this.gameDataIds && this.gameDataIds.length > 0
					? this.gameDataIds
					: this.users
			return source.map((_, index) => {
				const name = this.users[index]
				return name || `${this.$t('games.columns.user')} ${index + 1}`
			})
		},

		userIds() {
			if (this.gameDataIds && this.gameDataIds.length > 0) {
				return this.gameDataIds
			}
			return this.users
		},

		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},

		isTimer() {
			return !!this.initialTimer
		},

		isTrain() {
			return !this.isHomework
		},

		isMultiply() {
			return this.gameType.includes('multiply')
		},
		isDivide() {
			return this.gameType === 'divide'
		},
		columnWrapStyle() {
			if (!this.isMultiply && !this.isDivide) return
			if (this.windowWidth >= 1200) return

			return {
				'max-width': `${10 * 210}px`,
			}
		},

		numbersFontSize() {
			return this.userNames.length > 5 ? 50 : 70
		},

		// columnGroupStyle() {
		// 	if (!this.isMultiply) return;

		// 	if (this.userNames.length < 7) return;

		// 	return {
		// 		'flex-wrap': 'wrap'
		// 	}
		// }
	},

	methods: {
		operationSymbol(string) {
			// console.log('string', string)

			if (this.isMultiply) {
				return string.replace('*', 'x ').replace('+', '')
			}

			if (this.isDivide) {
				return string.replace('/', ' ÷ ').replace('+', '')
			}

			return string
		},
		prev() {
			if (this.step <= 0) {
				this.step !== 0 && (this.step = 0)
				return
			}
			this.step -= 1
		},
		next() {
			if (this.step >= this.maxStep - 1) {
				this.step !== this.maxStep && (this.step = this.maxStep)
				return
			}
			this.step += 1
		},

		countDownTimer() {
			if (!this.isTimerEnabled) return

			if (this.countDown > 0) {
				setTimeout(() => {
					this.countDown -= 1
					this.countDownTimer()
					if (this.countDown <= 3) {
						this.isTimeAlmostOver = true
					} else {
						this.isTimeAlmostOver && (this.isTimeAlmostOver = false)
					}
				}, 1000)
			} else {
				this.isTimeEnd = true
			}
		},
		howShow(userIndex) {
			if (this.view === VIEW.laptop) {
				if (this.step === 0) {
					return [0, 1, 2].includes(userIndex)
				} else if (this.step === 1 && this.step !== this.maxStep) {
					return [3, 4, 5].includes(userIndex)
				} else if (this.step === 2 && this.step !== this.maxStep) {
					return [6, 7, 8].includes(userIndex)
				} else if (this.step === 3 && this.step !== this.maxStep) {
					return [9].includes(userIndex)
				}
			} else if (this.view === VIEW.mobile) return userIndex === this.step
			else return true
		},
		submitResult(e, userIndex, userId) {
			e && e.preventDefault()
			let value = e.target.querySelector('input').value
			if (value) value = +value
			else value = null
			const expect = this.columnNumbers[userIndex].reduce((sum, current) => {
				console.log('sum', Number(sum), 'current', current)

				if (current.includes('*')) {
					const currentNumber = current.replace('*', '')

					return sum * Number(currentNumber)
				}

				if (current.includes('/')) {
					return parseInt(sum / Number(current.replace('/', '')))
				}

				return sum + Number(current)
			}, 0)

			// console.log("expect", expect)

			const correct = value === expect
			const hasBackendGameIds =
				Array.isArray(this.gameDataIds) && this.gameDataIds.length > 0
			const resolvedUserId = hasBackendGameIds
				? this.gameDataIds[userIndex]
				: this.isTrain
				? userId
					? `${userId}${userIndex}`
					: null
				: userId || null
			this.answers = update(this.answers, {
				[userIndex]: () => ({
					answer: value,
					correct,
					time: msCounter,
					user: this.userNames[userIndex],
					userId: resolvedUserId,
				}),
			})
			// if (this.view === VIEW.mobile || this.view === VIEW.laptop) this.step += 1

			if (this.view === VIEW.mobile) this.step = this.step + VIEW_NUM.mobile
			if (this.view === VIEW.laptop) {
				// userIndex
				if (
					(this.step === 0 &&
						this.answers[0] &&
						this.answers[1] &&
						this.answers[2]) ||
					(this.step === 1 &&
						this.answers[3] &&
						this.answers[4] &&
						this.answers[5]) ||
					(this.step === 2 &&
						this.answers[6] &&
						this.answers[7] &&
						this.answers[8]) ||
					(this.step === 3 && this.answers[9])
				) {
					this.step = this.step + 1
				}
			}
			// all users answered
			if (this.answers.filter(v => !v).length === 0)
				this.$emit('onSubmitAllColumns', this.answers, this.isTrain)
		},
		onResize() {
			this.windowWidth = window.innerWidth
			this.setMaxStep()
			if (this.windowWidth < 1200 && this.step !== 0) this.step = 0
			if (this.windowWidth < 1200 && this.windowWidth >= 768)
				this.view = VIEW.laptop
			else if (this.windowWidth < 768) this.view = VIEW.mobile
			else if (this.view !== VIEW.desktop && this.windowWidth >= 1200)
				this.view = VIEW.desktop
		},
		setMaxStep() {
			this.step = 0
			this.maxStep = Math.ceil(this.users.length / VIEW_NUM[this.view])
		},
		getResultByID(id, index) {
			return this.isTrain ? `${id}${index}` : `${id}`
		},
	},
	created() {
		msCounter = 0
		this.setMaxStep()
		this.countDown = this.initialTimer
	},
	updated() {
		this.$nextTick(function() {})
	},
	filters: {
		textCapitalize(str) {
			return !str ? '' : `${str[0].toUpperCase()}${str.slice(1)}`
		},
	},
	mounted() {
		const egg = document.querySelector('#egg')
		egg && egg.style && (egg.style.display = 'none')
		this.initialTimer && this.countDownTimer()
		const numberList = document.querySelector('[data-type="column-numbers"]')
		if (numberList) {
			this.fontSize =
				(numberList.offsetHeight + 400) / numberList.childElementCount -
				this.users.length
		}

		// if (this.users?.length) {
		// 	const length = this.users.length
		// 	const columnLength = this.columnNumbers.length
		//
		// 	if (length === 10) {
		// 		this.fontSize = 48
		//
		// 		if (columnLength === 10) {
		// 			this.fontSize = this.fontSize / 2
		// 		} else if (columnLength <= 9 && columnLength >= 5) {
		// 			this.fontSize = this.fontSize
		//
		// 		} else {
		// 			this.fontSize = this.fontSize * 2
		//
		// 		}
		//
		// 	} else if (length <= 9 && length >= 5) {
		// 		this.fontSize = 88
		// 	} else {
		// 		this.fontSize = 128
		// 	}
		// }
		this.answers = this.users.map(() => null)

		intervalId = setInterval(() => (msCounter += interval), interval)
		// window.addEventListener('resize', this.onResize)
	},
	beforeDestroy() {
		const egg = document.querySelector('#egg')
		egg && egg.style && (egg.style.display = 'block')
		clearTimeout(this.countDownTimer)
		clearInterval(intervalId)
		// window.removeEventListener('resize', this.onResize)
	},
}
</script>

<style scoped lang="scss">
// @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:700');

.column-wrap {
	background: #fff;
	z-index: 10;
	padding: 10px;
	margin: 10px;
	border-radius: 12px;
	width: fit-content;
	overflow-y: auto;
}

.slide-control {
	display: flex;
	justify-content: space-between;
	align-items: center;

	button {
		margin: 0 10px;
		display: flex;
		align-items: center;
		border: 0;
		background: transparent;
		outline: none;
		color: #e4467b;

		&:hover,
		&:active {
			font-weight: bold;
		}

		&:disabled {
			opacity: 0;
			color: #1b18184c;

			svg path {
				fill: #1b18184c;
			}
		}

		span {
			&:last-child {
				margin-left: 20px;
			}

			&:first-child {
				margin-right: 20px;
			}
		}
	}
}

.wrap-timer {
	display: flex;
	justify-content: center;
	margin-bottom: 10px;
}

.timer {
	padding: 5px 20px;
	align-items: center;
	background: #f3b12d;
	min-width: 80px;
	color: #fff !important;
	border-radius: 10em;
	font-size: 24px;
	display: flex;
	height: 40px;
	justify-content: center;

	span {
		line-height: 40px;
		margin-top: 5px;
		margin-left: 8px;
	}
}

.timeAlmostOver {
	background: #e4467b;
}

.timeIsOver {
	color: #e4467b;
	font-size: 38px;
	line-height: 38px;
}

.column-group {
	display: flex;
	flex-wrap: nowrap;
	overflow: auto;
	position: relative;
	/* to be higher than egg mascotte */
	z-index: 100;
	align-self: stretch;
	// width: 100%; //fit-content;
	margin: 0 auto;
	padding: 12px;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		border: 2px solid red;
		color: #e4467b;

		input {
			border: 1px solid grey;
		}
	}
}

.column-group.multiply {
	// flex-wrap: wrap;

	column-gap: 5px;
	// row-gap: 60px;

	// padding-right: 26px;
	// grid-auto-flow: column;
	// width: max-content;
	// grid-template-columns: repeat(5, auto);
}

@media (min-width: 1201px) {
	.column-group.multiply {
		width: max-content;
		margin: 0 auto;
		overflow: visible;
	}
}

.column {
	flex-grow: 1;
	overflow: hidden;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	border-right: 1px solid rgba(0, 0, 0, 0.5);
}

.column-group.multiply .column {
	min-width: 160px;

	border-right: 1px solid rgba(0, 0, 0, 0.2);
	border-left: 1px solid rgba(0, 0, 0, 0.2);
}

.column_disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.column:last-child {
	border-right: none;
}

.column-name {
	flex-shrink: 0;
	font-size: 30px;
	color: #333;
	// height: 1em;
	// line-height: 1em;
	overflow: hidden;
	white-space: nowrap;
	font-weight: bold;

	margin-top: 20px;
}

.column-task {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	background-color: #e85183;
	width: 44px;
	height: 44px;
	border-radius: 10em;
	font-size: 24px;
	margin: 10px auto;
}

.multiply-column-number {
	font-size: 42px;

	margin: 10px;
}

.column-number {
	flex-grow: 1;
	display: flex;
	margin: 0;
	flex-direction: column;
}

.column-number li {
	color: #333;
	justify-content: flex-end;
	display: flex;
	align-items: center;
	line-height: 1em;
	font-family: 'Roboto Condensed', sans-serif;
	flex-grow: 1;
	font-weight: 700;
	flex-shrink: 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.5);
	//font-size: 32px !important;
	padding: 1px 8px;

	@media (max-width: 1200px) {
		//font-size: 24px !important;
	}

	@media (max-width: 480px) {
		padding: 1px 8px;
		//font-size: 20px !important;
	}

	&:last-child {
		border-bottom: none;
	}
}

.column-number li:nth-child(odd) {
	background: rgba(0, 0, 0, 0.05);
}

.column-form {
	flex-shrink: 0;
	display: flex;
	align-items: stretch;
}

.input-wrap {
	outline: none;
	height: 42px;
	width: 8ch;
	flex-basis: calc(100% - 42px);
	font-size: 24px;
}

.input-wrap input {
	display: block;
	width: 100%;
	height: 100%;
}

.column-form button {
	position: relative;
	background-color: #e4467b;
	cursor: pointer;
	border: none;
	width: 42px;
	height: 42px;
}

.column-form[disabled],
.column-form input:disabled,
.column-form button:disabled {
	cursor: not-allowed;
}

.column-form button::after {
	content: '';
	position: absolute;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 10px 0 10px 20px;
	border-radius: 2px;
	top: 50%;
	transform: translate(-50%, -50%);
	left: 50%;
	border-color: transparent transparent transparent #fff;
}
</style>
